import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { WorkoutService, AlertService } from "../../../services";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import {
  WorkoutsState,
  Observable,
  Store,
  take,
  Types,
  AutoUnsubscribe,
  Subscription,
  StorageUtil,
  InputUtil,
  filter,
  map,
  of,
} from "../store";
import { Fields } from "../store";
import { DomSanitizer } from "@angular/platform-browser";
import * as lodash from "lodash";
import { InjuryService } from "../../../services/injury.service ";
import { ActivatedRoute } from "@angular/router";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";

@Component({
  selector: "app-injury-form",
  templateUrl: "./injury-form.component.html",
  styleUrls: ["./injury-form.component.css"],
})
@AutoUnsubscribe
export class InjuryFormComponent {
  Editor = ClassicEditor;

  @Input() formData;
  @Output() close = new EventEmitter();
  @Output() success = new EventEmitter();
  form: FormGroup;

  public teamID: number;
  public userID: number;
  public selectedInjuryLocation: string = ""; // '.././../../../assets/img/injuries/Chin.png';

  constructor(
    private fb: FormBuilder,
    private _service: InjuryService,
    private spinner: Ng4LoadingSpinnerService,
    private as: AlertService,
    private activeRoute: ActivatedRoute,
    private store: Store<WorkoutsState>,
    private ds: DomSanitizer
  ) {
    // this.teamID = +localStorage.getItem("teamId");

    this.userID = this.activeRoute.snapshot.params.playerID;
    this.teamID = this.activeRoute.snapshot.params.teamID;
    
    this.buildForm(this.teamID, this.userID);
  }

  public todayDateTime = new Date();

  onCancel(event) {
    this.close.emit(false);
  }

  private buildForm(teamID: number, userID: number) {
    this.form = this.fb.group({
      injuryclassificationID: [0, [Validators.required, Validators.min(1)]],
      injurylocationID: [0, [Validators.required, Validators.min(1)]],
      injuryoccuredID: [0, [Validators.required, Validators.min(1)]],
      injuryvenuetypeID: [0],
      injuryDate: [this.todayDateTime, Validators.required],
      injuryRecoveryDate: [null, Validators.required],
      needSportsTrainer: [false, Validators.required],
      needDoctor: [false, Validators.required],
      overrideoptionselected: [false, Validators.required],
      injurystatusID: [0, [Validators.required, Validators.min(1)]],
      injurystatusOverview: [""],
      teamID: [teamID],
      userID: [userID],
      addedBy: +StorageUtil.userID
    });
  }

  public showVenueTypes: boolean = false;
  onInjuryOccuredSelected(value) {
    // 1 - During Practise
    // 2 - During Game
    // 3 - On Their Own
    // 4 - Other
    console.log("onInjuryOccuredSelected ===> ", value);

    if (value == 1 || value == 2) {
      this.showVenueTypes = true;
      //Set Venue Type ID Required
      this.form
        .get("injuryvenuetypeID")
        .setValidators([Validators.required, Validators.min(1)]);
    } else {
      //reset venue type
      this.showVenueTypes = false;
      //Set Venue Type ID Required to False
      this.form.get("injuryvenuetypeID").clearValidators();
      this.form.patchValue({ injuryvenuetypeID: 0 });
    }
  }

  onInjuryLocationSelected(locationID) {
    var selectedLocation = this.formData.locations.find(
      (n) => n.injurylocationID == locationID
    );
    console.log("Selected location ==> ", selectedLocation);
    this.selectedInjuryLocation = selectedLocation.imageURL;
  }

  addInjuryToPlayer(event) {
    if (this.form.valid) {
      this.spinner.show();
      this._service.addInjuryToPlayer(this.form.value).subscribe(
        (result) => {
          this.spinner.hide();
          this.success.emit(false);
        },
        (error) => {
          this.spinner.hide();
          this.as.error("Could not save injury data");
        }
      );
    } else {
      this.as.error("Please, fill in all the fieds");
    }

    console.log("FORM DATA ==> ", this.form.value);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/workouts/injury-form/injury-form.component.ts